<template>
  <div>
    <h3>My Opportunities</h3>
    <b-alert variant="info" dismissible fade show>
      This page contains opportunities based on the following criteria:
      <ul>
        <li>Opportunities created by you</li>
        <li>
          Opportunities tied to an internship course that you are assigned to
        </li>
      </ul>
    </b-alert>
    <opportunities-list
      :opportunities="opportunities"
      :terms="terms"
      :term="term"
      :types="types"
    ></opportunities-list>
  </div>
</template>

<script>
import OpportunitiesList from "../../components/opportunities/opportunities-list";
import opportunitiesApi from "../../api/opportunity";
import termsApi from "../../api/terms";

export default {
  data() {
    return {
      opportunities: [],
      terms: [],
      types: [],
      term: null,
      type: null,
    };
  },

  components: {
    "opportunities-list": OpportunitiesList,
  },

  watch: {
    terms: function () {
      if (this.term === null) {
        //this.term = this.terms[0].termId;
        var foundTerm = _.find(this.terms, (t) => {
          var start = new Date(t.termStart);
          var end = new Date(t.termEnd);
          return start.getTime() <= Date.now() && end.getTime() >= Date.now();
        });
        if (foundTerm) {
          this.term = foundTerm.termId;
        }
      }
    },
  },

  created() {
    var that = this;
    opportunitiesApi
      .getOpportunitiesByUser()
      .then(function (response) {
        that.opportunities = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    opportunitiesApi.getOpportunityTypes().then((response) => {
      that.types = response.data;
    });

    termsApi.getTerms().then((response) => {
      this.terms = response.data;
    });
  },
};
</script>

<style scoped>
</style>
